import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select, Icon, Tooltip } from 'antd';
import './clickableItemWithSelect.scss';

const clickableItemWithSelect = props => {
  const { title, id, description, additionalText, value, isActive, options, callback } = props;
  const [ optionSelected, setOptionSelected ] = useState(options[0])
  const [ totPrice, setTotPrice ] = useState(value)

  let className = 'ClickableItemWithSelect ' + id;

  if (isActive) {
    className += ' active';
  }

  useEffect(() => {
    const calculatedPrice = value * optionSelected;
    setTotPrice(calculatedPrice);
  });

  const handleOnSelectChange = optionValue => {
    const calculatedPrice = value * optionValue;
    setOptionSelected(optionValue);
    setTotPrice(calculatedPrice);
    callback(id, calculatedPrice, optionValue);
  }

  const handleOnClick = () => {
    callback(id, isActive ? null : totPrice)
  }

  return (
    <div
      className={className}
      onClick={handleOnClick}
      data-value={value}
      data-key={id}
      title={description}
    >
      <span className={'title'}>{title}</span>
      <span onClick={event => event.stopPropagation()}>
        {options && options.length ? (
          <Select
            size="small"
            width="90"
            defaultValue={options[0]}
            onChange={handleOnSelectChange}
            disabled={!isActive}
          >
            {options.map(option => (
              <Select.Option key={option} value={option}>
                {option} ({(value * option)}€)
              </Select.Option>
            ))}
          </Select>
        ) : null}
        {additionalText && <span className={'description'}>{additionalText}</span>}
      </span>
      {description && <Tooltip title={description} className="offer-service-description-tooltip">
        <Icon type='info-circle' className="info-icon-span" />
      </Tooltip>}
    </div>
  );
};

clickableItemWithSelect.defaultProps = {
  description: '',
  isActive: false,
  callback: () => {},
};

clickableItemWithSelect.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number,
  description: PropTypes.string,
  value: PropTypes.any.isRequired,
  isActive: PropTypes.bool,
  callback: PropTypes.func,
};

export default clickableItemWithSelect;
